import { captureException } from './error';
import { addDurationToTime } from './date';

export const parseString = (str, ...variables) => {
  let string = str;
  for (const variable in variables) {
    string = string.replace('%s', variables[variable]);
  }
  return string;
};

export const toPersianNumber = (str) => {
  const string = str && str.toString();
  if (string && string.length > 0) {
    const persianNum = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    const chars = string.split('');
    for (const number in string) {
      if (/\d/.test(chars[number])) {
        chars[number] = persianNum[chars[number]];
      }
    }
    return chars.join('');
  }
};

export const checkRegex = (str, regex) => {
  if (!regex) return true;
  const patt = new RegExp(regex);
  const res = patt.exec(str);
  if (res === null) return false;
  let ok = false;
  for (let i = 0; i < res.length; i++) {
    if (res[i] === str) ok = true;
  }
  return ok;
};

export const formatPrice = (price) => {
  if (!price) return;
  return toPersianNumber(parseInt(price * 1000).toLocaleString());
};

export const getOS = () => {
  const { userAgent } = window.navigator;
  const { platform } = window.navigator;
  const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
  const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
  const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
  let os = null;
  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac OS';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows';
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
  } else if (!os && /Linux/.test(platform)) {
    os = 'Linux';
  }
  return os;
};

export const handleBlockSymbol = (evt) => {
  switch (evt.key) {
  case '-':
    evt.preventDefault();
    break;
  case '+':
    evt.preventDefault();
    break;
  case 'e':
    evt.preventDefault();
    break;
  default:
  }
};

export const slugify = (str) => {
  str = str.replace(/^\s+|\s+$/g, '');
  // Make the string lowercase
  str = str.toLowerCase();

  // Remove accents, swap ñ for n, etc
  const from =
    'ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;';
  const to =
    'AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------';
  for (let i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  // Remove invalid chars
  str = str
    .replace(/[^a-z0-9 -]/g, '')
    // Collapse whitespace and replace by -
    .replace(/\s+/g, '-')
    // Collapse dashes
    .replace(/-+/g, '-');

  return str;
};

export const isMobile = () => window.innerWidth < 600;

export const priceTransformer = (value, noSign) => {
  const sign = noSign ? '' : '$';
  const price = value === 0 ? 0 : (Math.round((Number(value) || 0) * 100) / 100).toFixed(
    2,
  );
  return `${sign}${price}`;
};

export const formatNumber = (n) =>
  /** Format the given number to a standard format */
  (n ? Number(n).toFixed(2) : '0.00');
export const statusHandling = (status) => {
  // if (status === 401) {
  //   setTimeout(() => {
  //     if (!window.location.pathname?.includes('login')) {
  //       window.location.href = '/login';
  //     }
  //   }, 1000);
  // }
};

// Deprecated
export const generateQueryOld = (queryArray) => {
  /** Get an array of queries and generate a query string */
  const validatedQueryArray = [];
  for (let i = 0; i < queryArray.length; i++) {
    const element = queryArray[i];
    if (element) {
      validatedQueryArray.push(element);
    }
  }

  return validatedQueryArray?.length ? `?${validatedQueryArray.join('&')}` : '';
};

export const isUrlStartsWith = (headerRoutes, pathname) => headerRoutes.filter((r) => pathname?.includes(r))?.length > 0;

export const truncString = (text, index) => (text?.length > index ? `${text?.slice(0, index)}...` : text);

export const isMobileSize = () => !(window.innerWidth > 900);

export const isPickup = (type) => type === 1;

export const isNumber = (val) => typeof val === 'number';

export const getQueryStringValue = (key) => new URLSearchParams(window.location.search).get(key);

export const createCookie = ({ name, value, expireTimeInMinutes }) => {
  let expires = '';
  if (expireTimeInMinutes) {
    const date = new Date();
    date.setTime(date.getTime() + expireTimeInMinutes * 60 * 1000);
    expires = `; expires=${date.toGMTString()}`;
  }
  document.cookie = `${name}=${value}${expires}; path=/`;
};

export const readCookie = (name) => {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const eraseCookie = (name) => {
  try {
    createCookie({ name, value: '', expireTimeInMinutes: -1 });
  } catch (e) {
    captureException(e);
  }
};

export const reformatRouteString = (str) => {
  let results = str.replace(/[^a-zA-Z0-9 ]/g, '');
  results = results.replace(
    /([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])/g,
    '',
  );
  results = results.replace(/\s+/g, '-').toLowerCase();
  return results;
};
